import { Alert, Text } from '@mantine/core';
import { IconX } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { formatDateTime } from '@feature/utils';

import { TravelRequest } from '../model/TravelRequestTypes';

interface TravelRequestCancellationAlertProps {
  request: TravelRequest;
}

export function TravelRequestCancellationAlert({ request }: TravelRequestCancellationAlertProps) {
  const { t } = useTranslation();
  const { cancellation } = request;

  if (cancellation == null) {
    return null;
  }

  return (
    <Alert
      color="gray"
      icon={<IconX />}
      title={t('travel.requests.cancellation.title')}
    >
      <Text size="sm">
        <Text
          span
          fw={500}
        >
          {t('travel.requests.cancellation.cancelledBy')}
        </Text>{' '}
        {cancellation.cancelledBy.name}, {formatDateTime(cancellation.cancelledAt)}
      </Text>
      <Text size="sm">
        <Text
          span
          fw={500}
        >
          {t('travel.requests.cancellation.reason')}
        </Text>{' '}
        {cancellation.reason}
      </Text>
    </Alert>
  );
}
